import {
  REGEX,
  PLATFORMS,
  CONVERSION,
  ACCOUNT_TYPES,
  PROFILE_TYPES,
  SELECTION_TYPES,
  SLUG_PLATFORM_MAP,
} from '@/constants';

export const blurActiveElement = () => document.activeElement.blur();

// todo perform proper validations of playlists
export const getPlatformByUrl = (url) => {
  let platform;

  if (url.includes(PLATFORMS.spotify)) {
    platform = PLATFORMS.spotify;
  } else if (url.includes(PLATFORMS.youtube)) {
    platform = PLATFORMS.youtube;
  } else if (url.includes(PLATFORMS.apple)) {
    platform = PLATFORMS.apple;
  }

  if (platform && REGEX[platform].test(url)) {
    return platform;
  }

  return null;
};

// todo perform proper validations of playlists
export const getPlatformByProfile = (url) => {
  let platform;

  if (url.includes(PLATFORMS.spotify)) {
    platform = PLATFORMS.spotify;
  } else if (url.includes(PLATFORMS.youtube)) {
    platform = PLATFORMS.youtube;
  } else if (url.includes(PLATFORMS.apple)) {
    platform = PLATFORMS.apple;
  }

  if (platform && REGEX.profile?.[platform]?.test(url)) {
    return platform;
  }

  return null;
};

export const getPlatformURL = (platform) => {
  if (platform === PLATFORMS.apple) {
    return `https://music.apple.com/library/all-playlists/`;
  } else if (platform === PLATFORMS.spotify) {
    return `https://open.spotify.com`;
  } else if (platform === PLATFORMS.youtube) {
    return `https://www.youtube.com/feed/playlists`;
  }

  return null;
};

export const getPlaylistIdFromUrl = (platform, url) => {
  const regex = platform && REGEX[platform];

  if (!regex || !url) return null;

  const match = url.match(regex);

  return match ? match[1] : null;
};

export const getPlaylistURL = (platform, playlistId) => {
  if (platform === PLATFORMS.apple) {
    return `https://music.apple.com/library/playlist/${playlistId}`;
  } else if (platform === PLATFORMS.spotify) {
    return `https://open.spotify.com/playlist/${playlistId}`;
  } else if (platform === PLATFORMS.youtube) {
    return `https://www.youtube.com/playlist?list=${playlistId}`;
  }

  return null;
};

export const is401 = (error) => error?.response?.status === 401;

export const getFormattedMessage = (message) => {
  let msg = message;

  if (msg && !msg.endsWith('!') && !msg.endsWith('.')) {
    msg += '.';
  }

  return msg;
};

export const getErrorDetails = (error) => {
  const response = error?.response;

  const { data, status } = response || {};

  const { code, context = {}, error: _error, message: _message } = data || {};

  const message =
    getFormattedMessage(_message || _error) || 'Something went wrong!';

  return {
    code,
    context,
    message,
    is401: status === 401,
    is403: status === 403,
    is429: status === 429,
    is500: status === 500,
  };
};

export const isApple = (platform) => platform && platform === PLATFORMS.apple;

export const isYoutube = (platform) =>
  platform && platform === PLATFORMS.youtube;

export const isFutureTime = (timestamp) => {
  const _timestamp = Number(timestamp);

  const now = Date.now();

  return Number.isFinite(_timestamp) && _timestamp > now;
};

export const titleCase = (string = '') => {
  return string.replace(/\b\p{L}/gu, (m) => m.toUpperCase());
};

export const slugToPlatform = (slug) => {
  const key = slug?.toLowerCase();

  return SLUG_PLATFORM_MAP[key] || key;
};

export const isSingleConversion = (type) => type === CONVERSION.single;

export const isAccountConversion = (type) => ACCOUNT_TYPES.includes(type);

export const isProfileConversion = (type) => PROFILE_TYPES.includes(type);

export const isSelectionConversion = (type) => SELECTION_TYPES.includes(type);
